module.exports = __webpack_public_path__ + "img/rr-logo.1eba62de.gif";